module.exports = __webpack_public_path__ + "static/media/error404.aa254f40.svg";